(function () {
  window.addEventListener("postscriptReady", () => {
    observeExitIntent();

    window.addEventListener(
      "exit-intent",
      (detail) => {
        function openPopup() {
          if (
            window.postscript &&
            typeof window.postscript.popups?.find === "function" &&
            typeof window.postscript.popups?.open === "function"
          ) {
            // Find the popup and open it
            window.postscript.popups.find().then((popupId) => {
              if (popupId) {
                window.postscript.popups.open(popupId);
              }
            });
          }
        }
        openPopup();
      },
      { once: true }
    );
  });
})();
